import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';
import { TOURNAMENT_ID } from '../config/app';

const createGroupFn = httpsCallable<
  {
    tournamentId: string;
    roundId: string;
    playerIds: string[];
    groupName?: string;
    useAiName: boolean;
  },
  { groupId: string; joinCode: string; groupName: string }
>(functions, 'createGroup');

const joinGroupFn = httpsCallable<
  { tournamentId: string; roundId: string; joinCode: string },
  { groupId: string; groupName: string }
>(functions, 'joinGroup');

const finaliseGroupFn = httpsCallable<
  { tournamentId: string; roundId: string; groupId: string },
  { success: boolean }
>(functions, 'finaliseGroup');

const publishRoundFn = httpsCallable<
  { tournamentId: string; roundId: string },
  { success: boolean }
>(functions, 'publishRound');

const closeRoundFn = httpsCallable<
  { tournamentId: string; roundId: string },
  { success: boolean }
>(functions, 'closeRound');

const deleteRoundFn = httpsCallable<
  { tournamentId: string; roundId: string },
  { success: boolean }
>(functions, 'deleteRound');

const generateGroupNameFn = httpsCallable<
  { tournamentId: string; roundId: string; playerIds: string[] },
  { name: string }
>(functions, 'generateGroupNamePreview');

export function createGroup(data: {
  roundId: string;
  playerIds: string[];
  groupName?: string;
  useAiName: boolean;
}) {
  return createGroupFn({ tournamentId: TOURNAMENT_ID, ...data });
}

export function joinGroup(data: { roundId: string; joinCode: string }) {
  return joinGroupFn({ tournamentId: TOURNAMENT_ID, ...data });
}

export function finaliseGroup(data: { roundId: string; groupId: string }) {
  return finaliseGroupFn({ tournamentId: TOURNAMENT_ID, ...data });
}

export function publishRound(data: { roundId: string }) {
  return publishRoundFn({ tournamentId: TOURNAMENT_ID, ...data });
}

export function closeRound(data: { roundId: string }) {
  return closeRoundFn({ tournamentId: TOURNAMENT_ID, ...data });
}

export function deleteRound(data: { roundId: string }) {
  return deleteRoundFn({ tournamentId: TOURNAMENT_ID, ...data });
}

export function generateGroupNamePreview(data: {
  roundId: string;
  playerIds: string[];
}) {
  return generateGroupNameFn({ tournamentId: TOURNAMENT_ID, ...data });
}
